import {useMutation, useQueryClient} from 'react-query';
import {useTranslation} from 'react-i18next';

import api from 'utils/api';
import {setAlert, setSuccessAlert} from 'actions/alerts';
import contentKeys from 'actions/content/queryKeys';

import playlistKeys from './queryKeys';

function useAddPlaylistSection(playlistId) {
	const {t} = useTranslation();
	const queryClient = useQueryClient();
	const queryKey = playlistKeys.singlePlaylist(playlistId);

	async function addPlaylistSection(sectionData) {
		return api(
			'post',
			`/api/playlists/${playlistId}/sections`,
			null,
			sectionData
		);
	}

	const {isLoading, isError, mutateAsync} = useMutation(addPlaylistSection, {
		onSuccess: () => {
			queryClient.invalidateQueries(queryKey);
			queryClient.invalidateQueries(contentKeys.contentLogs());
			setSuccessAlert({
				title: t('alert_section_added_successfully'),
			});
		},
		onError: () => {
			setAlert({
				title: t('alert_section_not_added'),
			});
		},
	});

	return {isLoading, isError, addPlaylistSection: mutateAsync};
}

export default useAddPlaylistSection;
